module.exports = __webpack_public_path__ + "img/eye.5a488db1.svg";